// Map CMS dropdown values to Algolia index slugs (resolved server-side via /api/search)
export const listingIndexSlugMap = {
  'Upcoming Events': 'upcoming-events',
  'Training and Development': 'training',
  'Resource Hub': 'resource-hub',
  // "news" resolves server-side to the Resource Hub index restricted to article/page documents.
  News: 'news',
  Global: 'global',
}

/**
 * @param {string | undefined | null} filteredContentType
 * @returns {string | null}
 */
export function resolveListingIndexSlug(filteredContentType) {
  if (!filteredContentType) return null
  return (
    listingIndexSlugMap[filteredContentType] ||
    filteredContentType.toLowerCase().replace(/\s+/g, '-')
  )
}

/**
 * Concatenates the listing filter query params (content-type / topic / trainingFormat)
 * onto an editor-provided base URL — the component's CTA "see all" link. The destination
 * comes from the CMS, never a hardcoded path.
 *
 * @param {string | undefined | null} baseUrl - the CTA link URL configured on the component
 * @param {string | undefined | null} filteredContentType
 * @param {string | undefined | null} filteredByTopic
 * @param {string | undefined | null} filteredByTrainingFormat
 * @returns {string | null} the base URL with params appended, or null when no base URL is given
 */
export function appendListingParams(
  baseUrl,
  filteredContentType,
  filteredByTopic,
  filteredByTrainingFormat,
) {
  if (!baseUrl) return null
  const indexSlug = resolveListingIndexSlug(filteredContentType)
  const params = new URLSearchParams()
  if (indexSlug && indexSlug !== 'global') params.set('content-type', indexSlug)
  // topic may be a single value or several — emit the comma form (?topic=AI,News), which
  // SearchResult reads back into the multi-topic filter.
  if (filteredByTopic) {
    const topics = (Array.isArray(filteredByTopic) ? filteredByTopic : [filteredByTopic]).filter(Boolean)
    if (topics.length) params.set('topic', topics.join(','))
  }
  if (filteredByTrainingFormat) params.set('trainingFormat', filteredByTrainingFormat)
  // URLSearchParams encodes commas as %2C — restore the readable comma form the search page parses.
  const qs = params.toString().replace(/%2C/gi, ',')
  if (!qs) return baseUrl
  const separator = baseUrl.includes('?') ? '&' : '?'
  return `${baseUrl}${separator}${qs}`
}
